import React from "react";
import SingleSelectBox from "../FormComponents/SingleSelectBox";
import Input from "../FormComponents/Input";

const EditRecordviewTable = ({ editElementData, setEditElementData, device }) => {
  const handleChange = (key, value) => {
    setEditElementData({ ...editElementData, [key]: value });
  };

  // if (device === "mobile") {
  //   return (
  //     <Input
  //       type="checkbox"
  //       checked={editElementData.disable_pagination}
  //       label="Disable Pagination"
  //       onChange={(e) => handleChange("disable_pagination", e.target.checked)}
  //     />
  //   );
  // }
  return (
    <div className="builder_form">
      {device !== "mobile" && (
        <SingleSelectBox
          selectedData={editElementData.layout_type}
          options={layoutOptions}
          onChange={(obj) => obj.id && handleChange("layout_type", obj.id)}
          label="Select Layout"
        />
      )}
      {editElementData.layout_type !== "table_view" && (
        <CatalogEditContainer catalog={editElementData.catalog} onChange={(data) => handleChange("catalog", data)} />
      )}
      <Input
        type="checkbox"
        checked={editElementData.disable_pagination}
        label="Disable Pagination"
        onChange={(e) => handleChange("disable_pagination", e.target.checked)}
      />
    </div>
  );
};

const CatalogEditContainer = ({ catalog, onChange }) => {
  const handleChange = (key, value) => {
    onChange({ ...catalog, [key]: value });
  };

  const handleChangeCardPerRow = (e) => {
    let value = e.target.value;

    if (value === "") {
      handleChange("cards_per_row", 1);
      return;
    }

    if (value.length > 1) {
      value = value.slice(-1);
    }

    value = parseInt(value, 10);
    value = Math.max(1, Math.min(6, value));

    handleChange("cards_per_row", value);
  };

  const handleGapChange = (e) => {
    let value = parseInt(e.target.value, 10);
    if (isNaN(value)) value = 0;
    value = Math.max(0, Math.min(100, value));
    handleChange("gap_between_cards", value);
  };

  return (
    <div className="builder_form">
      <Input
        type="number"
        label="Cards per Row"
        value={catalog.cards_per_row ?? 1}
        min={1}
        max={6}
        step={1}
        onChange={handleChangeCardPerRow}
      />
      <Input
        type="number"
        label="Gap Between Cards"
        value={catalog.gap_between_cards ?? 0}
        min={0}
        max={100}
        step={1}
        onChange={handleGapChange}
      />
    </div>
  );
};

const layoutOptions = [
  { id: "table_view", name: "table view only" },
  { id: "catalog_view", name: "catalog view only" },
  { id: "table_and_catalog_view", name: "table and catalog view" },
  { id: "catalog_and_table_view", name: "catalog and table view" }
];

export default EditRecordviewTable;
export { CatalogEditContainer };
